<template>
	<div>
		<data-table 
			tableId="main_acc_list"
			:header="this.tableHeader"
			:columns="this.tableColumns"
			:columnDefs="this.columnDefs"
			:columnSearch="this.columnSearch"
			:data="this.users"
			:drawCallback="this.openEditAccount"
		/>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { Utilities } from "../../utilities";
	import DataTable from "../DataTable";

	export default {
		props: ["breadcrumb", 'users', 'viewer', "search"],

		data(){
			let vm = this;

	        return {
	        	"currentCode": this.$route.params.code,
	            "actions": [],
	            "historyCode": "",

	            "tableHeader": ["Tài khoản","Tên","Ghi chú","Sửa","Trạng thái","Tín dụng","Số dư","Cấp dưới","Last login"],
	            "columnSearch": [{pos:0}, {pos:1}],
	            "tableColumns": [{data: 'code'},{data: 'fullname'},{data: 'note'},{data: 'code'},{data: 'status'},{data: 'budget'},{data: 'budget_remain'},{data: 'count_child'},{data: 'last_login'}],
	            "columnDefs": []
	        }
	    },
	    mounted(){
	    	this.initTable();
	    },
	    components: {
			'data-table': DataTable
		},
		watch: {
			users: function(u){
				let code = this.search !== "" ? this.search : this.$route.params.code;
				let length = code.length;
				if(u.length > 0 && this.search !== ""){
					length = u[0].code.length - 2;
				}
				let vm = this;
				if(length == 7){
					this.tableColumns = [{data: 'title'},{data: 'partner_user'},{data: 'fullname'},{data: 'note'},{data:'code'},{data: 'status'},{data: 'budget'},{data: 'budget_remain'},{data: 'count_child'},{data: 'created_at'},{data: 'expires_at'},{data: 'last_login'}];
					this.columnDefs = [
						{
							targets: 0,//code
							width: 90,
							render: function(data, type, full, meta) {
								let uname = data.toUpperCase();
	                            if(full.role_title != "player"){
	                                return '<a href="javascript:;" code="'+full.code+'" class="accountList code">' + uname + '</a>';
	                            }
	                            
	                            return "<span class='code' style='text-align: center;'>"+uname+"</span>";
							},
						},
						{
							targets: 1,//partner_user
							width: 100,
							render: function(data, type, full, meta) {
								return "<span style='float: left;'>"+data+"</span>";
							},
						},
						{
							targets: 2, //fullname
							render: function(data, type, full, meta) {
								data = data ? data : "";
								return "<span style='float: left;'>"+data+"</span>";
							},
						},
						{
							targets: 3, //note
							render: function(data, type, full, meta) {
								data = data ? data : "";
								return "<span style='float: left;text-align: left;'>"+data+"</span>";
							},
						},
						{
							targets: 4,
							width: 40,
							render: function(data, type, full, meta) {
								return '<div class="actionLinks">' +
					                    	'<a class="edit" code="'+full.code+'" href="javascript:;">Sửa</a>' +
				                     	'</div>';
							}
						},
						{
							targets: 5,
							render: function(data, type, full, meta) {
								let dis = vm.user.status != 1 ? "disabled" : "";
								return  '<select '+dis+' class="form-control user_status" origin="'+full.status+'" code="'+full.code+'" style="text-align-last: center;">' +
											'<option '+(full.status == 1 ? 'selected' : '')+' value="1">Mở</option>' +
		                                    '<option '+(full.status == 0 ? 'selected' : '')+' value="0">Suspend</option>' +
		                                    '<option '+(full.status == -1 ? 'selected' : '')+' value="-1">Khóa</option>' +
										'</select>';
							},
						},
						{
							targets: 6, //budget
							render: function(data, type, full, meta) {
								return "<span style='float:right;'>"+Utilities.formatNumber(data+"")+"</span>";
							},
						},
						{
							targets: 7, //budget_remain
							render: function(data, type, full, meta) {
								return "<span style='float:right;'>"+Utilities.formatNumber(data+"")+"</span>";
							},
						},
						{
							targets: 8,
							render: function(data, type, full, meta) {
								let tt = full.allow_bet === true ? "Chạy mạng" : "PMQL";
								let dis = Utilities.currency(full.count_child);
								let child = full.count_active_child ? Utilities.currency(full.count_active_child)+'/'+Utilities.currency(full.count_child) : Utilities.currency(full.count_child);
								return typeof full.allow_bet !== "undefined" ? tt : child;
							},
						},
						{
							targets: 10,
							render: function(data, type, full, meta) {
								let d = moment(full.created_at, "YYYY/MM/DD HH:mm:ss").format('DD/MM/YY');
								return d;
							},
						},
						{
							targets: 9,
							render: function(data, type, full, meta) {
								let isExpired = Utilities.isExpired(full.expires_at);
								let d = moment(full.expires_at, "YYYY/MM/DD HH:mm:ss").format('DD/MM/YY');
								let str = "<span class='"+(isExpired ? "expired" : "")+"'>"+d+"</span>";
								return str;
							},
						},
						{
							targets: 11,
							width: 120,
							render: function(data, type, full, meta) {
								let d = moment(data, "YYYY/MM/DD HH:mm:ss").format('DD/MM/YY HH:mm:ss');
								return d == "Invalid date" ? "" : d;
							},
						}
					];

					this.tableHeader = ["Tài khoản","Tên đăng nhập","Tên","Ghi chú","Sửa","Trạng thái","Tín dụng","Số dư","Loại","Hết hạn","Ngày tạo","Last login"];
				}else{
					this.tableColumns = [{data: 'code'},{data: 'fullname'},{data: 'note'},{data: 'code'},{data: 'status'},{data: 'budget'},{data: 'budget_remain'},{data: 'count_child'},{data: 'last_login'}];
					this.columnDefs = [
						{
							targets: 0,
							width: 90,
							render: function(data, type, full, meta) {
								let uname = data.toUpperCase();
	                            if(full.role_title != "player"){
	                                return '<a href="javascript:;" code="'+full.code+'" class="accountList code">' + uname + '</a>';
	                            }
	                            
	                            return "<span class='code' style='text-align: center;'>"+uname+"</span>";
							},
						},
						{
							targets: 1,
							render: function(data, type, full, meta) {
								data = data ? data : "";
								return "<span style='float: left;'>"+data+"</span>";
							},
						},
						{
							targets: 2,
							render: function(data, type, full, meta) {
								data = data ? data : "";
								return "<span style='float: left;text-align: left;'>"+data+"</span>";
							},
						},
						{
							targets: 3, // Tuy chinh
							width: 40,
							render: function(data, type, full, meta) {
								return '<div class="actionLinks">' +
					                    	'<a class="edit" code="'+full.code+'" href="javascript:;">Sửa</a>' +
				                     	'</div>';
							}
						},
						{
							targets: 4,
							render: function(data, type, full, meta) {
								let dis = vm.user.status != 1 ? "disabled" : "";
								return  '<select '+dis+' class="form-control user_status" origin="'+full.status+'" code="'+full.code+'" style="text-align-last: center;">' +
											'<option '+(full.status == 1 ? 'selected' : '')+' value="1">Mở</option>' +
		                                    '<option '+(full.status == 0 ? 'selected' : '')+' value="0">Suspend</option>' +
		                                    '<option '+(full.status == -1 ? 'selected' : '')+' value="-1">Khóa</option>' +
										'</select>';
							},
						},
						{
							targets: 5,
							render: function(data, type, full, meta) {
								return "<span style='float:right;'>"+Utilities.formatNumber(data)+"</span>";
							},
						},
						{
							targets: 6,
							render: function(data, type, full, meta) {
								return "<span style='float:right;'>"+Utilities.formatNumber(data)+"</span>";
							},
						},
						{
							targets: 7,
							render: function(data, type, full, meta) {
								let tt = full.allow_bet === true ? "Chạy mạng" : "PMQL";
								let dis = Utilities.currency(full.count_child);
								let child = (full.count_active_child || full.count_active_child === 0) ? Utilities.formatNumber(full.count_active_child)+'/'+Utilities.formatNumber(full.count_child) : Utilities.formatNumber(full.count_child);
								return typeof full.allow_bet !== "undefined" ? tt : child;
							},
						},
						{
							targets: 8,
							width: 120,
							render: function(data, type, full, meta) {
								let d = moment(data, "YYYY/MM/DD HH:mm:ss").format('DD/MM/YY HH:mm:ss');
								return d == "Invalid date" ? "" : d;
							},
						}
					]

					this.tableHeader = ["Tài khoản","Tên","Ghi chú","Sửa","Trạng thái","Tín dụng","Số dư","Cấp dưới","Last login"];
				}
			}
		},

	    computed: {
			...mapGetters({
		  		user: 'user'
			})
		},

		methods:{
			initTable: function(){
				var vm = this;
				let params = this.$route.params;
				
				// try{
	   //              $("#account_list").mDatatable().destroy();
	   //          }catch(e){}

				// $(document).off("click", ".m_datatable a.smsbetedit");
				// $(document).on("click", ".m_datatable a.smsbetedit", function(){
				// 	let ucode = $(this).attr("code");
				// 	let urole = $(this).attr("role");

    //                 vm.$router.push({ name: 'EditAccount', params: { code: ucode, role: urole } });
				// });

				// $(document).off("click", ".m_datatable a.history-activity");
				// $(document).on("click", ".m_datatable a.history-activity", function(){
				// 	let ucode = $(this).attr("code");
				// 	vm.historyCode = ucode;
				// 	// vm.$refs.history.initTable(ucode);
				// 	$('#act_history').modal('show');
    //                 // vm.$router.push({ name: 'EditAccount', params: { code: ucode, role: urole } });
				// });
				
				$(document).off("click", ".accountList");
                $(document).on("click", ".accountList", function(){
                    let ucode = $(this).attr("code");

                    vm.$router.push({ name: 'AccountList', params: { code: ucode } });
                });

				$(document).off("change", ".user_status");
                $(document).on("change", ".user_status", function(){
                	var current = $(this);
                    let ucode = current.attr("code");
                    let stt = current.val();
                    let origin = current.attr("origin");
                    let text = stt == 0 ? "suspend" : (stt == -1 ? "khóa" : "mở");

                    let swalOpt = {
                        title: "Bạn chắc chắn muốn " + text + " tài khoản &nbsp;<span style='color: red'>"+ ucode +"</span>?",
                        showCancelButton: true,
                        confirmButtonText: text,
                        cancelButtonText: "Hủy bỏ",
                        confirmButtonColor: "#cb5a5e",
                        allowOutsideClick: false
                    };

                    if(stt == -1){
                    	swalOpt.input = 'checkbox';
                    	swalOpt.inputPlaceholder = "Rút tín dụng tài khoản " + ucode + " và các tài khoản cấp dưới về 0";
                    }
             
                    swal(swalOpt).then(res => {
                    	if(res.dismiss){
                    		current.find("option").removeAttr("selected");
                        	current.find("option[value="+origin+"]").prop("selected", true);
                    	}else{
                    		var downZero = $("#swal2-checkbox").is(':checked');
	                        downZero = downZero === false ? 0 : 1;
	                        vm.banUser(stt, ucode, downZero);
                    	}
                    });
                });
			},

			banUser: function(stt, ucode, downZero){
				let data = {
					status: stt
				};

				if(downZero != 0){
					data.downZero = downZero;
				}

				let vm = this;
				mApp.blockPage({
				    overlayColor: '#000000',
				    type: 'loader',
				    state: 'primary',
				    message: 'Đang xử lý...'
				});

				axios.put("/admin-panel/user/ban/"+ucode, data)
					.then(res => {
						mApp.unblockPage();
						let code = vm.$route.params.code;
						if(code == "administrator") code = "";
						vm.$emit("reload-table", code);
					})
					.catch(function (error) {
						mApp.unblockPage();
						console.log(error);
					});
			},

			openEditAccount: function(){
				let vm = this;
				$(".actionLinks .edit").unbind("click").bind("click", function(){
					let code = $(this).attr("code");
                	vm.$router.push({ name: 'EditAccount', params: { code: code } });
                });
			}
		}
	}
</script>

<style>
	.breadcrumb-container {
		display: inline-block;
	    font-size: 1.15rem;
	    vertical-align: middle;
	}
	ol.breadcrumb {
	    padding: 0;
	    margin: 0;
	    background-color: initial;
	    margin-left: 10px;
	}
	.breadcrumb-item.active {
	    color: #6c757d;
	}
	.breadcrumb-item+.breadcrumb-item {
	    padding-left: .5rem;
	}
	.breadcrumb-item span, .breadcrumb-item a {
		text-transform: uppercase;
	}
	#account_list th, #account_list td{
		padding: 5px 5px;
	}
	.expired{
		color:red;
	}
	tr.suspend td, tr.suspend td a{
		color: #000;
	}
	tr.lock td, tr.lock td a{
	    text-decoration: line-through;
    	color: #000;
	}
	td[data-field=username]{
		font-weight: bold;
	}
	.acc-action{
		display: inline;
		margin-left: 2px;
	}
	.user_status{
		/*padding-top: 5px;
    	padding-bottom: 5px;
    	border: none;
	    background: none;*/
	    padding: 0px;
	}
	.searching{
		padding-top:5px;
	}
</style>